// IP pubblici del cliente (tenant_public_ips): confronto IPv4↔CIDR per i dettagli di alert e
// incident, dove l'IP di destinazione viene dal raw event e non passa dal backend. Stessa
// logica di backend/src/utils/cidr.ts.
export interface CustomerIpBlock {
  cidr: string;
  label: string | null;
  siteId: number | null;
  siteName: string | null;
}

function ipv4ToInt(ip: string): number | null {
  if (!/^\d{1,3}(\.\d{1,3}){3}$/.test(ip)) return null;
  const parts = ip.split('.').map(Number);
  if (parts.some(p => p > 255)) return null;
  return ((parts[0] << 24) | (parts[1] << 16) | (parts[2] << 8) | parts[3]) >>> 0;
}

function cidrContains(ip: string, cidr: string): boolean {
  const [rangeIp, bitsStr] = cidr.split('/');
  const ipInt = ipv4ToInt(ip);
  const rangeInt = ipv4ToInt(rangeIp);
  const bits = Number(bitsStr);
  if (ipInt === null || rangeInt === null || !Number.isInteger(bits) || bits < 0 || bits > 32) return false;
  if (bits === 0) return true;
  const mask = (0xFFFFFFFF << (32 - bits)) >>> 0;
  return (ipInt & mask) === (rangeInt & mask);
}

// Il blocco più specifico che contiene l'IP, o null.
export function matchCustomerIp(ip: string | null | undefined, blocks: CustomerIpBlock[] | undefined): CustomerIpBlock | null {
  if (!ip || !blocks?.length) return null;
  let best: CustomerIpBlock | null = null;
  for (const block of blocks) {
    if (!cidrContains(ip, block.cidr)) continue;
    if (!best || Number(block.cidr.split('/')[1]) > Number(best.cidr.split('/')[1])) best = block;
  }
  return best;
}
